import { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { postMABAA040 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import { formatDate, formatNumberWithCommas } from '../../../utils';

const MABAA040 = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    useEffect(() => {
        postMABAA040(id, { page })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    }, [id, page]);

    return (
        <div className="profile-content">
            <div className="title-profile">이력서 정보</div>
            <div className="member-basic-infor">
                <div className="title-table-info">작성된 이력서 목록</div>
                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                </div>
                <table className="table table-bordered member-infor">
                    <thead>
                        <tr>
                            <th style={{ width: '12%' }}>등록일</th>
                            <th style={{ width: '12%' }}>업데이트</th>
                            <th style={{ width: '12%' }}>상태</th>
                            <th style={{ width: '40%' }}>이력서 제목</th>
                            <th style={{ width: '12%' }}>지원건수</th>
                            <th style={{ width: '12%' }}>조회수</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((item, index) => {
                                const addDateFormated = item?.addDate ? formatDate(item?.addDate) : '';
                                const modDateFormated = item?.modDate ? formatDate(item?.modDate) : '';
                                const resumeLvl = item?.resumeLvl === 'Y' ? '공개' : '비공개';
                                return (
                                    <tr key={index}>
                                        <td>{addDateFormated}</td>
                                        <td>{modDateFormated}</td>
                                        <td>{resumeLvl}</td>
                                        <td>
                                            <Link to={`/mabaa050-${item?.seq}`}>{item?.title}</Link>
                                        </td>
                                        <td>{item?.countSendResume || '-'}</td>
                                        <td>{item?.visitedCnt}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td style={{ textAlign: 'center' }} colSpan="6">
                                    데이타가 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <Pagination pages={pages} />
            </div>
        </div>
    );
};
export default MABAA040;
